import { NewSelect } from '@carta/ink';
import * as React from 'react';
export default {
  NewSelect,
  React
};